<template>
<section class="mbs-wrap mbs022">
    <div class="mbs-inner clear">
        <LoginLeft/>
        <div class="mbs-right">
            <div class="tit">{{ $i18nUtil.trans("message.ApprovalNoti.001", "회원가입 신청 완료") }}</div>
            <div class="txt1">{{ $i18nUtil.trans("message.ApprovalNoti.002", "가입이 신청되었습니다.") }}</div>
            <div class="txt2" v-html="$i18nUtil.trans('message.ApprovalNoti.003', '<b>관리자 승인 후</b> 최종가입이 완료되며, <br>최종가입 완료 시 <b>안내 메일이 발송됩니다.</b>')"></div>
        </div>
    </div>
</section>
</template>

<script>
import LoginLeft from "../../login/base/LoginLeft"
export default {
    components : {
        LoginLeft
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/join/base/ApprovalNoti.vue